import { global_hooks } from 'src/globals';

global_hooks.on('init', init);
function init() {
	if (document.querySelector('.ff_form_steps')) {
		import('./form_steps');
	}
}
